const ADMIN_PATH_PREFIXES = ['/admin', '/morgoth'];

/** Frontend journey analytics is restricted to the member-facing site. */
export const isAdminAnalyticsPath = (
  pathname: string | null | undefined
): boolean => {
  if (!pathname) return false;
  const normalizedPath = pathname.split(/[?#]/, 1)[0];
  return ADMIN_PATH_PREFIXES.some(
    (prefix) =>
      normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`)
  );
};

export const isMemberAnalyticsPath = (
  pathname: string | null | undefined
): boolean => !isAdminAnalyticsPath(pathname);
